// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__N5PnF","Footer":"Footer_Footer__xprX6","LogoContainer":"Footer_LogoContainer__RwDMl"};